import { useQuery } from '@tanstack/react-query';
import { templateApi, type Template } from '../api/templateApi';

// Re-export Template type for convenience
export type { Template };

// Query Keys
export const templateQueryKeys = {
  all: ['templates'] as const,
  config: ['templates', 'config'] as const,
};

/**
 * Hook to fetch available templates configuration
 */
export function useTemplates() {
  return useQuery<Template[]>({
    queryKey: templateQueryKeys.config,
    queryFn: () => templateApi.getTemplatesConfig(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: 2,
    retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
}

